import { render, staticRenderFns } from "./wall-data-item.vue?vue&type=template&id=1bb966cb&scoped=true"
import script from "./wall-data-item.vue?vue&type=script&lang=js"
export * from "./wall-data-item.vue?vue&type=script&lang=js"
import style0 from "./wall-data-item.vue?vue&type=style&index=0&id=1bb966cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb966cb",
  null
  
)

export default component.exports